import type { FC } from 'react'

import type { SxProps, Theme } from '@mui/material'
import { Box, Typography } from '@mui/material'

import { HOME_CONTENT } from '../defaults'

export const HeroSection: FC = () => (
  <Box sx={heroContainerSx}>
    <Typography component="h1" sx={headlineSx}>
      {HOME_CONTENT.headline}
    </Typography>
  </Box>
)

const heroContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  pt: { xs: 8, md: 14 },
  pb: { xs: 4, md: 6 },
  px: { xs: 2, md: 4 },
}

const headlineSx: SxProps<Theme> = {
  color: 'text.primary',
  fontSize: { xs: '2rem', md: '3.25rem' },
  fontWeight: 600,
  textAlign: 'center',
  maxWidth: 720,
  lineHeight: 1.2,
}
